import * as constants from './constants';

const defaultState = {
    consumeList: {},
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case constants.CONSUME_LIST:
            return {...state, consumeList: action.value}
        default:
            return state;
    }
}